module.exports = __webpack_public_path__ + "static/gray-menu-smoke-logo-212772d31da17817612a3d239184fa85.mp4";